import { createContext, useContext, useState } from "react";
import Spinner from "react-bootstrap/Spinner";
export const PageLoader = () => {
  return (
    <div className="fixed-inset flex-center bg-black bg-opacity-20">
      <Spinner animation="border" variant="primary" />
    </div>
  );
};
const LoaderContext = createContext();

export const LoaderProvider = ({ children }) => {
  const [loading, setLoading] = useState(false);

  return (
    <LoaderContext.Provider value={{ loading, setLoading }}>
      {/* Auto-render the overlay if loading */}
      {loading && <PageLoader />}

      {children}
    </LoaderContext.Provider>
  );
};

export const useLoader = () => useContext(LoaderContext);
